'use client';
import { useState } from 'react';
import clsx from 'clsx';
import { Typography } from '@bgzt/ui';
import { AUTHORIZED_SHOPS } from '~/constants/shop';
import { utilStyles } from '~/styles';
import styles from './ShopDescription.module.css';

type Props = {
  shopId: string;
};
export const ShopDescription = ({ shopId }: Props) => {
  const [showAll, setShowAll] = useState(false);

  const renderShopDescription = (_shopId?: string) => {
    switch (_shopId) {
      case AUTHORIZED_SHOPS.mandarake.id:
        return '만다라케는 일본을 대표하는 세계 최대 서브컬처 상점 중 하나로, 빈티지 피규어, 프라모델, 애니메이션, 만화, 게임 등 백만여 개 이상의 다양하고 유니크한 수집품을 판매합니다.';
      case AUTHORIZED_SHOPS.ragTag.id:
        return '래그태그(RAGTAG)는 1985년, 일본 패션의 중심지 도쿄 하라주쿠에서 시작된 중고 디자이너 브랜드 전문 스토어입니다. 꼼꼼한 품질 관리를 거친 프리미엄 브랜드의 중고 의류, 가방, 신발, 액세서리 등을 합리적인 가격에 선보이며, 감각 있는 패션 애호가들에게 꾸준한 사랑을 받고 있습니다.';
      default:
        return '';
    }
  };
  return (
    <>
      <div className={styles.container}>
        <div className={clsx(styles.description, !showAll && utilStyles.doubleLineEllipticalText)}>
          <Typography variant="B5" color="gray-900">
            {renderShopDescription(shopId)}
          </Typography>
        </div>
        <button type="button" onClick={() => setShowAll(!showAll)}>
          <Typography variant="B5" color="gray-400" className={styles.showAllButtonText}>
            {showAll ? '접기' : '펼치기'}
          </Typography>
        </button>
      </div>
    </>
  );
};
